import { render, staticRenderFns } from "./vipQuestionBank copy.vue?vue&type=template&id=1f5696ce&scoped=true&"
import script from "./vipQuestionBank copy.vue?vue&type=script&lang=js&"
export * from "./vipQuestionBank copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5696ce",
  null
  
)

export default component.exports